// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root___oGIg","additionalInfo":"AgreementModal_additionalInfo__NCmiB"};